import { v4 as uuidv4 } from 'uuid';

const DEFAULT_TEMP_PREFIX = 'temp';

/**
 * Generates a unique temporary ID using UUID v4 for
 * better uniqueness and security guarantees
 */
export const generateTempId = (prefix: string = DEFAULT_TEMP_PREFIX): string => {
  return `${prefix}-${uuidv4()}`;
};

/**
 * Checks if an ID is a temporary ID created by generateTempId
 */
export const isTempId = (id: string | null | undefined): boolean => {
  if (!id) {
    return true; // Treat falsy IDs as temporary
  }
  return id.startsWith(`${DEFAULT_TEMP_PREFIX}-`);
};
